module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "TOC"
    }
  }, [_c('h1', [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "href": "#/003dedication"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "acknowledgments"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/004acknowledgments"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "introduction"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/006introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "pa1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/007part1"
    }
  }, [_vm._v("East Texas Meets The Deep South")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/008chapter1"
    }
  }, [_vm._v("Mama Marion’s Mandelbroidt")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/009chapter2"
    }
  }, [_vm._v("Chocolate-Peanut Clusters")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/010chapter3"
    }
  }, [_vm._v("Cran-Pistachio Cookies")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/011chapter4"
    }
  }, [_vm._v("Dulce De Leche Bread Pudding")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/012chapter5"
    }
  }, [_vm._v("Jenay’s Famous Lemon Bars")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/013chapter6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Mansion On Turtle Creek Raspberry Brownies")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/014chapter7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Loaded Pecan Tassies")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/015chapter8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Coconut Dream Pie")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/016chapter9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Righteous Red Velvet Cake")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/017chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dolled-Up Sweet Potato Pound Cake")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/018chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mint Julep Fruitcake")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/019chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Deep-Fried Coke")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/020chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Texas Twister (Chocolate-Orange) Marshmallows")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/021chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Banana Pudding Ice Cream")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/022chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Frozen Peach Custard")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/023chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Margarita Snow Cones")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/024chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Sweetest Tea")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "pa2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/025part2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Head For The Hills (Of Central Texas)")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/026chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kerbey Lane’s Gingerbread Pancakes")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/027chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Apricot Kolaches")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/028chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mighty Fine Peach Cobbler")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/029chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Threadgill’s Pecan Pie")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/030chapter22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bud’s Round Top Buttermilk Pie")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/031chapter23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bumbleberry Cutie Pies")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/032chapter24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Texas Big Hairs (Lemon-Lime Meringue Tarts)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/033chapter25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Yes, Sauerkraut Cake")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/034chapter26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("German Chocolate Carrot Cake")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/035chapter27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1886 Chocolate Cake")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/036chapter28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Very Berry Trifle In A Jar")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/037chapter29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ancho-Choco Truffles")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/038chapter30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Almond Flan À La Fonda San Miguel")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch31"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/039chapter31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chocolate I Scream Sandwiches")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/040chapter32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Big Red Granita")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "pa3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/041part3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("South To The Border")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch33"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/042chapter33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lucky Buñuelos with Honeyed Fruit Salsa")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch34"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/043chapter34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Churros Buenos")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch35"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/044chapter35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sweet Pineapple Tamales with Cointreau Cream")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch36"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/045chapter36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pan Dulce Conchas")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch37"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/046chapter37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mexican Wedding Cookies")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch38"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/047chapter38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pumpkin Empanadas")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch39"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/048chapter39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Luby’s Chocolate Icebox Pie")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch40"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/049chapter40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Poteet Strawberry Cake")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch41"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/050chapter41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Strange Family’s Caramel-Apple Cake")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch42"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/051chapter42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Put The Lime In The Coconut Cake")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch43"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/052chapter43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cora’s Hummingbird Cake")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch44"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/053chapter44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sen. Zaffirini’s Praline Pecans")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch45"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/054chapter45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Orange-Kissed Fig Ice Cream")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch46"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/055chapter46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hatch Chile And Avocado Ice Cream")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch47"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/056chapter47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Minty Melon Pops")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "pa4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/057part4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Where The Wild West Meets The Mild Plains")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch48"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/058chapter48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Homemade Funnel Cakes with Spiked Whipped Cream")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch49"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/059chapter49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spicy Chocolate-Pepita Cookies")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch50"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/060chapter50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Laura Bush’s Cowboy Cookies")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch51"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/061chapter51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Almond Lace Cookies")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch52"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/062chapter52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dutch Oven Cobbler with Buttermilk-Lime Ice Cream")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch53"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/063chapter53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Blueberry Fried Pies")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch54"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/064chapter54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Deep Chocolate Meringue Pie")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch55"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/065chapter55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Patricia’s Piecrusts")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "blockquote",
    attrs: {
      "id": "sec_1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/065chapter55#sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Butter Pastry")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote",
    attrs: {
      "id": "sec_2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/065chapter55#sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Standard Pie Pastry")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch56"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/066chapter56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Perini Ranch Strawberry Shortcakes")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch57"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/067chapter57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cherry Dr Pepper Cupcakes")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch58"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/068chapter58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Good Ol’ Texas Sheet Cake")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch59"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/069chapter59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grandmother Shaughnessy’s Lemon Sponge Cake")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch60"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/070chapter60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Babe’s Banana Cake with Creamy Nut Frosting")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch61"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/071chapter61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tres Leches Cake")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch62"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/072chapter62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Strong Coffee Custard")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch63"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/073chapter63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Watermelon Soup Ooh La Lah")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "com"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/074comegetyou",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Come Get You Some: Top Twenty Texas Treats")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sources"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/075sources",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sources")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "per"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/076permissions",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Permissions")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ind"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/077index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "tab"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/078table",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Table of Equivalents")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/079abouttheauthor",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/080copyright",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e9eade36","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/005toc.vue
// module id = 69
// module chunks = 0